import React from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import tickImg from './images/success.svg';
import { onFinishedWebView } from '../../helper/mobile';

const PaymentSuccess = () => {
  return(
    <Container className='min-vh-100 diet-done'>
      <Row className='min-vh-100 justify-content-center align-items-center'>
        <Col className='text-center'>
          <img src={tickImg} className='mb-3' />
          <h5>Payment was made successfully</h5>
          <ul>
            <li>We shall send you a link to a form on your phone number.</li>
            <li>Our nutrition team will reach out to you within the next 48-72 hours after the submission of the form.</li>
          </ul>
        </Col>
      </Row>
      <Button className='diet-payment-btn btn-diet-done' onClick={() => onFinishedWebView()}>Okay</Button>
    </Container>
  );
}

export default PaymentSuccess;